export type ScanInventoryType = 'd365' | 'pms'

export function inferScanTypeFromCode(code: string): ScanInventoryType {
  return /\$Serial/i.test(code.trim()) ? 'd365' : 'pms'
}
